// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"logs_pageWrapper__1uSw3"};